import { storeToRefs } from 'pinia';
import type { Ref } from 'vue';
import { computed } from 'vue';
import { i18n } from '@/core/lib/i18n';
import { EnumLanguage, SportType } from '@/interface/enum';
import { useCustomerStore } from '@/store/customerStore';
import { useToggleStore } from '@/store/toggleStore';

const StatisticsWindow = {
    name: 'Statistics',
    config: 'scrollbars=no,resizable=no,width=1000,height=600',
};

interface IStatisticsEvent {
    hasStatistics: boolean;
    sportType: SportType;
    id: number;
}

export function useStatistics(event: Ref<IStatisticsEvent | null>) {
    const { isStatisticsEnabled } = storeToRefs(useToggleStore());
    const isStatisticsAvailable = computed(() => isStatisticsEnabled.value && (event.value?.hasStatistics ?? false));

    const { brandName } = storeToRefs(useCustomerStore());

    function openMuayThaiStatistics() {
        const lang = i18n.locale.value === EnumLanguage.TH_TH ? 'th' : 'en';
        const url = `/mt-statistics.html?matchId=${event.value?.id}&lang=${lang}&brandType=${brandName.value}`;

        window.open(url, StatisticsWindow.name, StatisticsWindow.config);
    }

    function _openStatistics() {
        const lang = EnumLanguage.toStatistics(i18n.locale.value);
        const brand = brandName.value.toLowerCase();
        const url = __URL_STATISTIC__
            .replace('{brand}', brand)
            .replace('{lang}', lang)
            .replace('{matchId}', String(event.value!.id));
        window.open(url, StatisticsWindow.name, StatisticsWindow.config);
    }

    function openStatistics() {
        if (!event.value) return;
        if (event.value.sportType === SportType.MuayThai) {
            openMuayThaiStatistics();
        } else {
            _openStatistics();
        }
    }

    return {
        isStatisticsAvailable,
        openStatistics,
    };
}
